<template>
  <v-navigation-drawer
      id="core-navigation-drawer"
      v-model="drawer"
      :color="drawerColor"
      app
      dark
      width="280"
  >
    <v-list class="py-0" dense nav>
      <v-list-item two-line>
        <v-list-item-avatar>
          <v-icon dark>mdi-account-circle</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Welcome</v-list-item-title>
          <v-list-item-title>{{
              loggedInUser.data.username
            }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list>
      <div v-for="(item, i) in items" :key="i">
        <div v-if="!item.subLinks" class="-mx-3">
          <div v-if="isAllowed(item)">
            <v-list-item :to="item.to" class="tile mx-2">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                    color="white--text"
                    v-text="item.title"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
        <div v-else>
          <v-list-group v-if="isSubLinkAllowed(item.subLinks)" class="-mx-4">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title color="white--text">{{
                      item.title == 'Dashboard PreService' ? 'PreService' : item.title
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <div v-for="sublink in item.subLinks" :key="sublink.title">
              <div v-if="isAllowed(sublink)">
                <v-list-item :to="sublink.to">
                  <v-list-item-content class="tile">
                    <v-list-item-title
                        color="white--text"
                        v-text="sublink.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
          </v-list-group>
        </div>
      </div>
    </v-list>

    <template v-slot:append>
      <v-divider></v-divider>
      <div class="pa-0">
        <v-list class="pa-0">
          <a @click="openChangePass()">
            <v-list-item class="bottom-tile">
              <v-list-item-icon class="bottom-tile-icon">
                <v-icon style="color: lightgray"
                >mdi-form-textbox-password
                </v-icon
                >
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                    class="bottom-tile-title"
                    style="color: lightgray"
                >
                  Change Password
                </v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </a>
          <a @click="logout()">
            <v-list-item class="bottom-tile">
              <v-list-item-icon class="bottom-tile-icon">
                <v-icon style="color: lightgray">exit_to_app</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                    class="bottom-tile-title"
                    style="color: lightgray"
                >Logout
                </v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </a>
        </v-list>
      </div>
    </template>

    <template>
      <v-dialog v-model="changePasswordDialog" persistent width="30%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >Change Password

            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >
          <v-divider></v-divider>
          <ChangePassword
              v-if="changePasswordDialog"
              @close="changePasswordDialog = false"
          ></ChangePassword>
        </v-card>
      </v-dialog>
    </template>
  </v-navigation-drawer>
</template>

<script>
import {getUser} from "@/utils/helper";
import ChangePassword from "../../components/Login/ChangePassword.vue";
import {LOGOUT} from "@/store/actions.type";

export default {

  /*{
    title: "Accredited CPD Provider Report",
    to: "/accreditedCpdProviderReport",
  },*/
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ChangePassword,
  },

  data: () => ({
    loggedInUser: "",
    drawerColor: "#34495e",
    barColor: "hsla(0,0%,100%,.45)",
    drawer: true,
    items: [
      {
        icon: "mdi-view-dashboard",
        title: "Dashboard",

        subLinks: [
          {
            title: "Dashboard",
            to: "/dashboard",
          },
          {
            title: "PreService",
            to: "/preservice",
          },
          {
            title: "Map",
            to: "/map",
          },
          {
            title: "Online Status",
            to: "/onlineStatus",
          },
        ],
      },
      {
        icon: "mdi-import",
        title: "Pre-service",
        to: "/pre-service",
      },
      {
        icon: "mdi-clipboard-text",
        title: "CPD Management",
        subLinks: [
          {
            title: "CPD Accreditor",
            to: "/accreditor",
          },
          {
            title: "CPD Provider",
            to: "/cpdProvider",
          },
          {
            title: "Course",
            to: "/course",
          },
          {
            title: "CPD Activity",
            to: "/cpdActivity",
          },
          {
            title: "Trainer",
            to: "/trainer",
          },
          {
            title: "Trainee",
            to: "/traineeRegistration",
          },
          {
            title: "Program Event",
            to: "/programEvent",
          },
        ],
      },
      {
        icon: "mdi-clipboard-plus",
        title: "Monitoring",
        to: "/graduateTracking",
      },
      {
        icon: "mdi-cog",
        title: "Settings",
        subLinks: [
          {
            title: "Roles",
            to: "/role",
          },
          {
            title: "User Groups",
            to: "/userGroup",
          },
          {
            title: "Permissions",
            to: "/permission",
          },
          {
            title: "Users",
            to: "/user",
          },
          {
            title: "Menu Items",
            to: "/menuItem",
          },
        ],
      },
      {
        icon: "mdi-file-document-multiple",
        title: "Reports",
        subLinks: [
          {
            title: "Training Event Report",
            to: "/trainingEventReport",
          },
          {
            title: "CPD Provider Report",
            to: "/cpdReport",
          },
          {
            title: "CPD Accreditor Report",
            to: "/accreditorReport",
          },
          {
            title: "Accredited Course Report",
            to: "/accreditedCourseReport",
          },
          {
            title: "Accreditation Summary Report",
            to: "/accreditationSummaryReport",
          },
          {
            title: "Training Detail Report",
            to: "/trainingDetailReport",
          },
          {
            title: "Preservice Report",
            to: "/preserviceReport",
          },
          {
            title: "Renewal Status Report",
            to: "/renewalStatusReport",
          },
          {
            title: "Trainee Report",
            to: "/traineeReport",
          },
          {
            title: "Trainer Report",
            to: "/trainerReport"
          },
          {
            title: "Course Report",
            to: "/courseReport",
          }
        ],
      },
      {
        icon: "mdi-card-plus",
        title: "Lookups",
        subLinks: [
          {
            title: "Health Professions",
            to: "/healthProfessions",
          },
          {
            title: "Mfr",
            to: "/mfr",
          },
          {
            title: "Universities",
            to: "/universities",
          },
          {
            title: "Certificate Reasons",
            to: "/certificateReasons",
          },
          {
            title: "Educational Programs",
            to: "/educationalPrograms",
          },
          {
            title: "Disciplines",
            to: "/disciplines",
          },
          {
            title: "Level of Studies",
            to: "/levelOfStudies",
          },
          {
            title: "Facilities",
            to: "/Facilities",
          },
          {
            title: "Trainer Selection Criteria",
            to: "/trainerSelectionCriteria",
          },
          {
            title: "Trainee Facilities",
            to: "/traineeFacilities",
          }
        ],
      },
    ],
    changePasswordDialog: false,
  }),
  async created() {
    this.loggedInUser = getUser();
  },
  methods: {
    isAllowed(item) {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == item.title &&
              permission.canRead == true
      );
    },
    isSubLinkAllowed(subLinks) {
      const subs = subLinks.filter((sublink) =>
          getUser().permissions.some(
              (permission) =>
                  permission.menuItem.menuItemName == sublink.title &&
                  permission.canRead == true
          )
      );
      return subs.length > 0 ? true : false;
    },
    closeDialog() {
      this.changePasswordDialog = false;
    },
    openChangePass() {
      this.changePasswordDialog = true;
    },
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style scoped>
.v-list .v-list-item--active {
  padding-left: 20px;
  color: rgb(64, 158, 255);
  background-color: rgb(48, 65, 86) !important;
}

.tile {
  color: rgb(191, 203, 217);
  margin: 5px;
  border-radius: 4px;
  height: 56px;
  line-height: 56px;
  font-size: 14px;
  padding: 0 20px;
  list-style: none;
  cursor: pointer;
  position: relative;
}

.bottom-tile {
  color: lightgray !important;
  font-size: 5px !important;
  height: 10px;
}

.bottom-tile-icon {
  font-size: 5px !important;
  letter-spacing: unset;
  min-height: 2px;
}

.bottom-tile-content {
  color: lightgray !important;
  font-size: 5px !important;
  height: 10px;
}
</style>
